import { createAsyncThunk } from "@reduxjs/toolkit";
import { IAddHeatmapData } from "../../apis/IApisInterface";
import { showSnackbar } from "../../slices/SnackbarSlice";
import { adminAddHeatmapScanApi } from "../../apis";
import { adminDeleteHeatMapApi, adminEditHeatmapApi, adminReportHeatmapApi } from "../../apis/AdminApis/AdminHeatmapApi";

export const adminAddHeatmapScanAction = createAsyncThunk("add/admin-heatmap/scan", async (data: IAddHeatmapData, { rejectWithValue, dispatch }) => {
    try {
        const response = await adminAddHeatmapScanApi(data)
        dispatch(showSnackbar({ message: response?.data?.message || "keyword added successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add keyword" });
    }
})
export const adminHeatmapDeleteAction = createAsyncThunk("delete/admin-heatmap", async (ids: string[], { rejectWithValue, dispatch }) => {
    try {
        const response = await adminDeleteHeatMapApi(ids)
        dispatch(showSnackbar({ message: response?.data?.message || "HeatMap Delete successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add keyword" });
    }
})
export const adminEditHeatmapAction = createAsyncThunk("edit/admin-heatmap", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await adminEditHeatmapApi(payload)
        dispatch(showSnackbar({ message: response?.data?.message || "HeatMap Edit successfully!", type: "success" }));
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add keyword" });
    }
})
export const adminHeatmapReportAction = createAsyncThunk("report/admin-heatmap", async (payload: any, { rejectWithValue, dispatch }) => {
    try {
        const response = await adminReportHeatmapApi(payload)
        return response.data
    } catch (error: any) {
        dispatch(showSnackbar({ message: error?.response?.data?.message, type: "error" }));
        return rejectWithValue(error || { message: "Could not add keyword" });
    }
})